import React from "react";
import OmronResults from "../components/app/Results/Results";
import OmronPagination from "../components/app/Pagination/Pagination";
import OmronFilter from "../components/app/Filters/Filter";
import AppLayoutWrapper from "./AppLayoutWrapper";
import OmronDownload from "../components/app/DownloadResult/Download";
import OmronSearchAllResults from "../components/app/SearchAllResults/SearchAllResults";
import { ResultSelectProvider } from "../providers/ResultSelectContext";
import FooterInfo from "../components/app/Footer/FooterInfo";

const AppLayout = () => {
  return (
    <AppLayoutWrapper>
      <ResultSelectProvider>
        <OmronFilter />
        <div className="p-result">
          <OmronDownload />
          <OmronSearchAllResults />
          <OmronResults />
          <OmronPagination />
          {/* <FooterInfo/> */}
        </div>
      </ResultSelectProvider>
    </AppLayoutWrapper>
  );
};

export default AppLayout;
